import AvisoLegal from './AvisoLegal'
export default AvisoLegal
